import { render, staticRenderFns } from "./BasePageTabs.vue?vue&type=template&id=6f5557b0&scoped=true&"
import script from "./BasePageTabs.vue?vue&type=script&setup=true&lang=ts&"
export * from "./BasePageTabs.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./BasePageTabs.vue?vue&type=style&index=0&id=6f5557b0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5557b0",
  null
  
)

export default component.exports